export function formEducator() {
    let $formEducator = $('.create-educator');
    let $eventType = $('#event_type');
    let $catsCourses = $('#cats_courses');
    let $courses = $('#courses');

    let inputs = $formEducator.find("input:visible:not('.button'),textarea:visible").filter("[required]");
    let selects = $formEducator.find("select:visible");

    function change_inputs() {
        inputs.each(function () {
            let $this = $(this);

            $this.on('input', function (e) {
                let $this = $(this);
                let value = $this.val();

                console.log('inp' + value);

                if (value !== '') {
                    $this.removeClass('error');
                } else {
                    $this.addClass('error');
                }
            });
        });
    }

    change_inputs();

    selects.each(function () {
        let $this = $(this);

        $this.on('change', function () {
            let value = this.value;

            if (value !== '') {
                $this.next('.select2').removeClass('error');
            } else {
                $this.next('.select2').addClass('error');
            }
        });
    });

    $eventType.on('change', function () {
        let parent = $eventType.parent();

        parent.siblings('.form-row').addClass('hide');
        parent.siblings('.form-row.' + this.value).removeClass('hide');

        inputs = $formEducator.find("input:visible:not('.button'),textarea:visible").filter("[required]");

        change_inputs();
    });

    $catsCourses.on('change', function () {
        var data = {
            'action': 'get_children_courses',
            'cat': this.value,
        };

        $.ajax({
            url: ajax_params.ajaxurl,
            data: data,
            type: 'POST',
            beforeSend: function () {
                $catsCourses.attr('disabled', true);
                $courses.html('').attr('disabled', true);
            },
            success: function (response) {
                if (response) {
                    $courses.html(response).attr('disabled', false);
                }
            },
            complete: function () {
                $catsCourses.attr('disabled', false);
            }
        });
    });

    $formEducator.submit(function (e) {
        e.preventDefault();

        let errorMessage = $('.response-error');

        inputs.each(function () {
            let $this = $(this);

            if ($this.val() === '') {
                $this.addClass('error');
            }
        });

        selects.each(function () {
            let $this = $(this);
            let value = $this.find(":selected").val();

            if (value !== '') {
                $this.next('.select2').removeClass('error');
            } else {
                $this.next('.select2').addClass('error');
            }
        });

        let $errors = $('.error');

        if ($errors.length) {
            errorMessage.show();

        } else {
            errorMessage.hide();

            let data = {
                'action': 'create_educator',
                'data': $formEducator.serializeArray()
            };

            $.ajax({
                url: ajax_params.ajaxurl,
                data: data,
                type: 'POST',
                beforeSend: function () {
                    $(".form-preloader").addClass("active");
                },
                success: function (response) {
                    if (response.status === true) {
                        $formEducator.hide();
                        $('.response-success').text(response.message).show();

                        $("html, body").animate({scrollTop: 0}, 500);

                    } else {
                        errorMessage.text(response.message);
                    }
                },
                complete: function () {
                    $(".form-preloader").removeClass("active");
                }
            });
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/form-educator.js